import { __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
import { SharedHttp } from '../../../services/http-client.service';
import { Router } from '@angular/router';
import { AuthService } from '../../../services/auth.service';
import { WebsiteThemeService } from '../../../services/website-theme.service';
import { DomSanitizer } from '@angular/platform-browser';
import { PersonalVerificationService } from '../../../services/personal-verification.service';
import { TranslateObjectPipe } from '../../../pipes/translate-object.pipe';
/**
 * Modal Component
 */
let VerifyLetterModalComponent = class VerifyLetterModalComponent {
    constructor(httpClient, router, auth, sanitizer, themeService, personalVerificationService, translateObjectPipe) {
        this.httpClient = httpClient;
        this.router = router;
        this.auth = auth;
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.personalVerificationService = personalVerificationService;
        this.translateObjectPipe = translateObjectPipe;
        this.addressData = {};
        this.successColor = '';
        this.inputBackColor = '';
        this.inputTextColor = '';
        this.secondColor = '';
        this.backColor = '';
        this.linkColor = '';
        this.borderRadiusSmaller = '';
        this.borderRadiusLarger = '';
        this.errorColor = '';
        this.loadingSpinner = true;
        this.loadingError = false;
        this.allPostOffices = [];
        this.keyword = 'output';
        this.selectedPostOffice = null;
        this.dropdownInFocus = false;
        this.placeholderText = '';
        document.documentElement.style.overflowY = 'hidden';
        this.auth.fetchUser();
        this.user = JSON.parse(localStorage.getItem('user'));
        this.addressData = this.user;
        this.addressData.object_type = 'private';
        this.themeService.getTheme().subscribe((data) => {
            this.successColor = this.themeService.getStyleAttribute('success_color');
            this.errorColor = this.themeService.getStyleAttribute('error_color');
            this.inputTextColor = this.themeService.getStyleAttribute('input_text_color');
            this.inputBackColor = this.themeService.getStyleAttribute('input_background_color');
            this.secondColor = this.themeService.getStyleAttribute('secondary_text_color');
            this.backColor = this.themeService.getStyleAttribute('modal_back_color');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
            this.linkColor = this.themeService.getStyleAttribute('link_color');
        });
        this.placeholderText = this.translateObjectPipe.transform('VERIFY.POSTOFFICE_PLACEHOLDER');
        this.personalVerificationService.loadPostOffices().then((result) => {
            if (result) {
                let tmpPOs = this.personalVerificationService.getAllPostOffices();
                for (let i = 0; i < tmpPOs.length; i++) {
                    tmpPOs[i].output = tmpPOs[i].name + ', ' + tmpPOs[i].address + ', ' + tmpPOs[i].postal_code;
                }
                this.allPostOffices = tmpPOs;
                this.loadingSpinner = false;
                this.loadingError = false;
            }
        });
    }
    selectPostOffice(item) {
        this.selectedPostOffice = item;
        this.addressData.address = this.selectedPostOffice.address;
        this.addressData.post_code = this.selectedPostOffice.postal_code;
        this.addressData.city = this.selectedPostOffice.name;
        this.checkPostOffice();
    }
    preventPropagation(e) {
        e.stopPropagation();
    }
    onChangeSearchPostOffice(val) {
    }
    onFocusedPostOffice(e) {
        this.dropdownInFocus = e;
    }
    onPOClear(e) {
        this.selectedPostOffice = null;
        this.addressData.post_code = null;
        this.addressData.address = null;
    }
    close() {
        this.selectedPostOffice = null;
        this.router.navigateByUrl('verify');
        this.modal.destroy();
    }
    closeModal() {
        document.documentElement.style.overflowY = '';
        this.selectedPostOffice = null;
        this.modal.destroy();
    }
    onSelectionChange(entry) {
        this.addressData.object_type = entry;
    }
    checkPost() {
        const regex = /^[0-9]*$/;
        if (this.addressData.post_code) {
            if (this.addressData.post_code.length !== 5 || !regex.test(this.addressData.post_code)) {
                this.postError = true;
            }
            else {
                this.postError = false;
            }
        }
        else {
            this.postError = true;
        }
    }
    checkPostOffice() {
        this.postOfficeError = this.selectedPostOffice == null;
    }
    checkPlace() {
        if (this.addressData.address) {
            if (this.addressData.address.length < 2) {
                this.addressError = true;
            }
            else {
                this.addressError = false;
            }
        }
        else {
            this.addressError = true;
        }
    }
    checkCity() {
        if (this.addressData.city) {
            if (this.addressData.city.length < 2) {
                this.cityError = true;
            }
            else {
                this.cityError = false;
            }
        }
        else {
            this.cityError = true;
        }
    }
    checkName() {
        const values = this.addressData.name.split(' ').filter(function (v) { return v !== ''; });
        if (values.length > 1) {
            this.nameError = false;
        }
        else {
            this.nameError = true;
        }
    }
    checkBusiness() {
        if (this.addressData.company_name) {
            if (this.addressData.company_name.length < 2) {
                this.businessError = true;
            }
            else {
                this.businessError = false;
            }
        }
        else {
            this.businessError = true;
        }
    }
    submit() {
        this.checkName();
        this.checkPlace();
        this.checkPost();
        this.checkCity();
        if (this.addressData.object_type === 'business') {
            this.checkBusiness();
        }
        else {
            this.businessError = false;
        }
        if (this.addressError ||
            this.nameError ||
            this.postError ||
            this.cityError ||
            this.businessError) {
            this.postOfficeError = true;
        }
        else {
            this.addressData.verification_method_code = 'letter';
            this.httpClient.post('user/setpersonalverificationmethod', this.addressData).subscribe((data) => {
                this.success();
                this.closeModal();
            });
        }
    }
};
VerifyLetterModalComponent.ctorParameters = () => [
    { type: SharedHttp },
    { type: Router },
    { type: AuthService },
    { type: DomSanitizer },
    { type: WebsiteThemeService },
    { type: PersonalVerificationService },
    { type: TranslateObjectPipe }
];
VerifyLetterModalComponent = __decorate([
    Component({
        selector: 'ecd-verify-letter-modal',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./verify-letter-modal.component.html")).default
    })
], VerifyLetterModalComponent);
export { VerifyLetterModalComponent };
